import { endpoints } from '@api'
import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { useTreatmentPlan } from '@hooks'
import React from 'react'
import { useQuery } from 'react-query'
import { ScrollableContent } from '../components/scrollable-content'
import { useAssistPanelContext } from '../context'
import { AssistPanelOverlay } from '../overlay-panel'
import AssignedAssessments from './assigned/selector'
import Progress from './progress'
import Suggestions from './suggestions'

const Assessments = () => {
  const { client } = useTreatmentPlan()
  const { setOverlayPanel } = useAssistPanelContext()
  const patientId = client?.id

  const { isLoading, data: assessmentScores } = useQuery(
    [endpoints.getPatientAssessmentScores.getCacheId(), patientId],
    () =>
      endpoints.getPatientAssessmentScores.request({
        patientId,
        includeFreeTextQuestions: true
      })
  )

  const handleViewResults = (data = {}) => {
    setOverlayPanel(AssistPanelOverlay.ASSESSMENT_RESULTS, data)
  }

  const handleAssignAssessment = (assessment: any) => {
    if (client?.enrollment_timestamp) {
      setOverlayPanel(AssistPanelOverlay.ASSIGN_ASSESSMENTS, {
        assessment: {
          clinicAssessmentId: assessment.clinicAssessmentId,
          cadenceValue: assessment.cadenceValue,
          cadenceUnit: assessment.cadenceUnit
        }
      })
    } else {
      setOverlayPanel(AssistPanelOverlay.ENROLL_CLIENT, {
        assessment: {
          clinicAssessmentId: assessment.clinicAssessmentId,
          cadenceValue: assessment.cadenceValue,
          cadenceUnit: assessment.cadenceUnit
        }
      })
    }
  }

  return (
    <ScrollableContent>
      <Progress
        isLoading={isLoading}
        allAssessmentScores={assessmentScores}
        patient={client}
        onViewResults={handleViewResults}
      />
      <Suggestions />
      <Box>
        <HStack justifyContent="space-between">
          <Text fontWeight="bold">Assigned</Text>
          <Button
            variant="link"
            textDecoration="none"
            onClick={() =>
              setOverlayPanel(AssistPanelOverlay.LIBRARY, {
                onAssign: handleAssignAssessment
              })
            }
            data-click-text="Browse library"
          >
            Browse library
          </Button>
        </HStack>
        <AssignedAssessments patient={client} user_id={client?.id} />
      </Box>
    </ScrollableContent>
  )
}

export default Assessments
